const searchBarInput = document.querySelector('.search-input');
const dropdownContainer =
	document.querySelector('.header-search-bar .search-bar-dropdown') ||
	document.querySelector('.featured-search-bar .search-results');

if (searchBarInput && dropdownContainer) {
	searchBarInput.addEventListener('focus', () => {
		// Create ad container
		const adDiv = document.createElement('div');
		adDiv.id = 'search_bar-ad';
		dropdownContainer.appendChild(adDiv);

		// Send ad request
		const adUnitCode = createAdUnitCode('search_bar');
		if (adUnitCode) {
			// Queue the slot rather than calling googletag directly: the host may
			// hold back gpt.js until the consent prompt is dismissed, in which case
			// googletag is still the { cmd: [] } stub when the search bar is first
			// focused. Since this listener is { once: true }, throwing here would
			// lose the search bar ad for the rest of the pageview.
			window.googletag = window.googletag || { cmd: [] };
			googletag.cmd.push(() => {
				const gptSlot = googletag.defineSlot(adUnitCode, [4, 4], adDiv.id);
				gptSlot.addService(googletag.pubads());
				googletag.display(gptSlot);
				googletag.pubads().refresh([gptSlot]);

				const onSlotRenderEnded = (event) => {
					if (event.slot === gptSlot) {
						googletag.pubads().removeEventListener("slotRenderEnded", onSlotRenderEnded);

						if (!event.isEmpty) {
							const style = document.createElement('style');
							style.textContent = `
								.results-container > .search-result:nth-child(n + 10) {
									display: none;
								}
							`;
							document.head.appendChild(style);
						}
					}
				};
				googletag.pubads().addEventListener("slotRenderEnded", onSlotRenderEnded);
			});
		}
	}, { once: true });
}

function createAdUnitCode(slotName) {
	const adData = window.tagEngineDataLayer?.adDataAdc;

	if (adData?.adSlots) {
		let adUnitCode = Object.values(adData.adSlots)[0].adUnitCode.split('/');
		adUnitCode[4] = slotName;
		return adUnitCode.join('/').replace('-p', '').replace('-v', '');
	}

	return '';
};
